import type { Model } from '@patsnap/tahiti-core/common/model';
import type { DualViewSetting } from '../types';

export const DualViewSettingModel = Symbol.for('DualViewSettingModel');

export interface DualViewSettingModel extends Model<DualViewSetting> {}
